import React from "react";
import Breadcrumb from "./Breadcrumb";


const CharterPage = () => {
  return (
    <>
    <Breadcrumb currentPage='Этический кодекс' />
    <div className="charter-page wrapper">
      <header className="ethical-header">

          <h2>Этический кодекс Международной Бизнес Ассоциации "Альянс предпринимателей СНГ"</h2>

      </header>

      <main className="charter-content">
        {/* Раздел 1 */}
        <section className="charter-section">
          <h2>1. Общие положения</h2>
            <p>1.1. Этический кодекс Международной Бизнес Ассоциации "Альянс предпринимателей СНГ" (далее — Кодекс) устанавливает обязательные нормы поведения для членов Ассоциации, направленные на поддержание высоких стандартов деловой этики и содействие развитию предпринимательского сообщества стран СНГ.</p>
            <p>1.2. Кодекс обязателен для всех членов Ассоциации и распространяется на их профессиональную деятельность, взаимодействие с партнерами, клиентами, коллегами и широкой общественностью.</p>
            <p>1.3. Настоящий Кодекс отражает основные ценности Ассоциации, включая честность, профессионализм, прозрачность, социальную ответственность и уважение к другим.</p>
        </section>

        {/* Раздел 2 */}
        <section className="charter-section">
          <h2>2. Профессиональная компетентность и ответственность</h2>
            <p>2.1. Члены Ассоциации обязаны стремиться к постоянному совершенствованию своих профессиональных навыков и знаний, следить за развитием современных технологий и бизнес-тенденций.</p>
            <p>2.2. Члены Ассоциации обязаны выполнять свои профессиональные обязанности качественно, добросовестно и в срок, проявляя ответственность перед партнерами и клиентами.</p>
            <p>2.3. Члены Ассоциации обязаны соблюдать законы, нормативные акты, а также внутренние правила и регламенты Ассоциации, демонстрируя высокий уровень правовой и профессиональной культуры.</p>
        </section>

        {/* Раздел 3 */}
        <section className="charter-section">
          <h2>3. Честность и прозрачность</h2>
        <p>3.1. Члены Ассоциации обязаны действовать честно и прозрачно в своих деловых отношениях, предоставляя достоверную информацию и избегая любых форм обмана.</p>
        <p>3.2. Уважение интеллектуальной собственности является обязательным. Члены Ассоциации обязаны избегать плагиата, неправомерного использования идей или результатов работы других лиц.</p>
        <p>3.3. Все члены Ассоциации обязаны раскрывать информацию о возможных конфликтах интересов и избегать ситуаций, которые могут повлиять на их объективность или вызвать сомнения в их честности.</p>
        </section>

        {/* Остальные разделы */}
        <section className="charter-section">
          <h2>4. Уважение и сотрудничество</h2>
        <p>4.1. Члены Ассоциации обязаны уважать права, достоинство и взгляды своих партнеров, коллег и других участников профессионального сообщества.</p>
        <p>4.2. Ассоциация поощряет атмосферу сотрудничества, взаимопомощи и обмена опытом. Члены Ассоциации обязаны активно способствовать созданию таких условий.</p>
        <p>4.3. Недобросовестная конкуренция, включая распространение ложной информации о конкурентах, строго запрещена. Члены Ассоциации обязаны поддерживать честные рыночные отношения и способствовать формированию здоровой конкурентной среды.</p>
        </section>

        <section className="charter-section">
          <h2>5. Защита данных и конфиденциальность</h2>
        <p>5.1. Члены Ассоциации обязаны уважать конфиденциальность информации, полученной в рамках профессиональной деятельности, и принимать все необходимые меры для защиты персональных данных, коммерческой и служебной тайны.</p>
        <p>5.2. Использование информации в личных интересах, в нарушение законов или деловой этики, строго запрещено.</p>
        </section>

        <section className="charter-section">
          <h2>6. Социальная ответственность и устойчивое развитие</h2>
        <p>6.1. Члены Ассоциации обязаны принимать активное участие в проектах, направленных на устойчивое развитие и социальную ответственность, включая благотворительность, поддержку образования и улучшение делового климата.</p>
        <p>6.2. Члены Ассоциации обязаны участвовать в инициативах, способствующих экономическому росту и развитию стран СНГ, ориентируясь на долгосрочные результаты.</p>
        <p>6.3. Ассоциация поощряет использование технологий и подходов, способствующих улучшению качества жизни и решению социальных проблем.</p>
        </section>

        <section className="charter-section">
          <h2>7. Заключительные положения</h2>
        <p>7.1. Настоящий Кодекс вступает в силу с момента его утверждения Общим собранием Ассоциации и является обязательным для всех членов.</p>
        <p>7.2. Нарушение положений Кодекса может повлечь за собой дисциплинарные меры, включая предупреждение, приостановление или прекращение членства.</p>
        <p>7.3. Контроль за соблюдением положений Кодекса осуществляется этической комиссией Ассоциации, которая рассматривает жалобы и принимает решения в отношении нарушений.</p>
        <p>7.4. Любые изменения или дополнения в настоящий Кодекс утверждаются Общим собранием Ассоциации.</p>
        </section>
      </main>
    </div>
    </>
  );
};

export default CharterPage;
